export const BADGE_LABEL_PT = {
  new: 'Novo',
  improved: 'Ajustado',
  fixed: 'Corrigido',
};

export function getBadgeLabel(types) {
  if (!Array.isArray(types) || types.length === 0) return null;
  if (types.includes('new')) return 'new';
  if (types.includes('improved')) return 'improved';
  if (types.includes('fixed')) return 'fixed';
  return types[0] ? String(types[0]).toLowerCase() : null;
}

export function getBadgeLabelPt(badgeKey) {
  if (!badgeKey) return '';
  const key = String(badgeKey).toLowerCase();
  return BADGE_LABEL_PT[key] || badgeKey;
}

export function normalizeVersion(s) {
  if (!s || typeof s !== 'string') return '';
  return s.trim().replace(/^v/i, '');
}

export function entryMatchesVersion(entry, currentVersion) {
  const v = normalizeVersion(currentVersion);
  if (!v) return true;
  const labels = entry.labels || [];
  return labels.some((l) => normalizeVersion((l.name || '').trim()) === v);
}

export const CHANGELOG_SEEN_KEY = 'changelog_seen_';

export function getChangelogSeen(version) {
  if (!version || typeof version !== 'string') return false;
  try {
    return !!localStorage.getItem(CHANGELOG_SEEN_KEY + version.trim());
  } catch (_) {
    return false;
  }
}
